import { ThemeProvider as NextThemesProvider } from 'next-themes';
import type { ReactNode } from 'react';

/**
 * Two equal themes (REDESIGN-2 section 3), with the explicit choice beating the
 * OS -- which is exactly next-themes' default once `enableSystem` is on: it
 * follows the system until someone picks, then remembers the pick.
 */
export function ThemeProvider({ children }: { children: ReactNode }) {
  return (
    <NextThemesProvider
      attribute="class"
      defaultTheme="system"
      enableSystem
      disableTransitionOnChange
    >
      {children}
    </NextThemesProvider>
  );
}
